import * as React from 'react';
import { ErrorLogComponent, ILogger } from '@cian/error-log-component';

import { ActionAfterViewed, EPercentVisible } from '@cian/action-after-viewed-component';

import { CalculatorLink, CostEstimate, MarketPrice } from '../../components';
import { ChartContainer } from '../ChartContainer';
import { useCostEstimateFeatureData } from './utils/useCostEstimateFeatureData';
import { hasChartData } from './utils/hasChartData';
import { trackEstimateClick, trackCostEstimateVisible } from '../../tracking';
import { getPriceSubtitle } from './utils/getPriceSubtitle';
import { getEstimationTitle } from './utils/getEstimationTitle';

interface ICostEstimateContainerProps {
  logger: ILogger;
}

export const CostEstimateContainer: React.FC<ICostEstimateContainerProps> = props => {
  const { offer, offerType, dealType, priceHistoryChartData, agent, costEstimate } = useCostEstimateFeatureData();
  const priceSubtitle = getPriceSubtitle(dealType);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const trackRedirect = React.useCallback(() => trackEstimateClick(offer, agent), []);
  const estimationTitle = React.useMemo(() => getEstimationTitle(offerType), [offerType]);

  if (!costEstimate || !(costEstimate.estimatedPrice || hasChartData(priceHistoryChartData))) {
    return null;
  }

  const { estimatedPrice, calculatorLink } = costEstimate;

  return (
    <ActionAfterViewed
      callback={trackCostEstimateVisible}
      percentVisible={EPercentVisible.Percent100}
      timeoutCallback={1000}
    >
      <CostEstimate
        title={estimationTitle}
        marketPrice={estimatedPrice ? <MarketPrice price={estimatedPrice} subtitle={priceSubtitle} /> : null}
        chart={
          hasChartData(priceHistoryChartData) ? (
            <ErrorLogComponent logger={props.logger}>
              <ChartContainer priceHistoryChartData={priceHistoryChartData} dealType={dealType} />
            </ErrorLogComponent>
          ) : null
        }
        calculatorLink={calculatorLink ? <CalculatorLink link={calculatorLink} onClick={trackRedirect} /> : null}
      />
    </ActionAfterViewed>
  );
};
